module.exports = __webpack_public_path__ + "2edce85d383974c399ca5908dde63c90.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img6.png
// module id = 1325
// module chunks = 0